export const messages = {
  en: {
    adminInout: {
      search: {
        title: 'Search Conditions',
        inputUserName: 'Please enter user name',
        inputPhone: 'Please enter phone number',
        inputStartTime: 'Please enter start time',
        inputEndTime: 'Please enter end time',
        selectAccessControl: 'Please select access control',
        selectOpenStatus: 'Please select open status'
      },
      list: {
        title: 'Access Records'
      },
      table: {
        face: 'Face',
        communityName: 'Community Name',
        number: 'Number',
        deviceName: 'Device Name',
        deviceCode: 'Device Code',
        userName: 'User Name',
        openType: 'Open Type',
        phone: 'Phone',
        idCard: 'ID Card',
        similarity: 'Similarity',
        openStatus: 'Open Status',
        openTime: 'Open Time'
      },
      allCommunities: 'All Communities',
      faceOpen: 'Face Open',
      otherOpen: 'Other',
      openSuccess: 'Open Success',
      openFailed: 'Open Failed'
    }
  },
  zh: {
    adminInout: {
      search: {
        title: '查询条件',
        inputUserName: '请填写用户名称',
        inputPhone: '请填写手机号',
        inputStartTime: '请输入开始时间',
        inputEndTime: '请输入结束时间',
        selectAccessControl: '请选择门禁',
        selectOpenStatus: '请选择开门状态'
      },
      list: {
        title: '进出记录'
      },
      table: {
        face: '人脸',
        communityName: '小区名称',
        number: '编号',
        deviceName: '设备名称',
        deviceCode: '设备编码',
        userName: '用户名称',
        openType: '开门方式',
        phone: '手机号',
        idCard: '用户身份证',
        similarity: '相似度',
        openStatus: '开门状态',
        openTime: '开门时间'
      },
      allCommunities: '全部小区',
      faceOpen: '人脸开门',
otherOpen: '其他',
      openSuccess: '开门成功',
      openFailed: '开门失败'
    }
  },
  'zh-TW': {
    adminInout: {
      search: {
        title: '查詢條件',
        inputUserName: '請填寫用戶名稱',
        inputPhone: '請填寫手機號',
        inputStartTime: '請輸入開始時間',
        inputEndTime: '請輸入結束時間',
        selectAccessControl: '請選擇門禁',
        selectOpenStatus: '請選擇開門狀態'
      },
      list: {
        title: '進出記錄'
      },
      table: {
        face: '人臉',
        communityName: '小區名稱',
        number: '編號',
        deviceName: '設備名稱',
        deviceCode: '設備編碼',
        userName: '用戶名稱',
        openType: '開門方式',
        phone: '手機號',
        idCard: '用戶身份證',
        similarity: '相似度',
        openStatus: '開門狀態',
        openTime: '開門時間'
      },
      allCommunities: '全部小區',
      faceOpen: '人臉開門',
      otherOpen: '其他',
      openSuccess: '開門成功',
      openFailed: '開門失敗'
    }
  }
}